import { Transaction } from "@common/types/transaction";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { EntityAvatar } from "@components/avatar/EntityAvatar";

interface Props {
    transaction: Transaction;
}

export const TransactionEntityContent: React.FC<Props> = ({ transaction }) =>
    transaction.entity ? (
        <div>
            <AvatarTooltip content={transaction.entity.name}>
                <EntityAvatar entity={transaction.entity} size="sm" />
            </AvatarTooltip>
        </div>
    ) : null;
